import { createSlice } from "@reduxjs/toolkit";
import { nonprofitsListApi } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nonprofitsSlice = createSlice({
  name: "nonprofits",
  initialState: data,
  reducers: {
    nonprofitsSlice(state) {
      state.isLoading = true;
    },
    nonprofitsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    nonprofitsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nonprofitsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nonprofitsHandler = (
  params:{
    all:boolean,
    search?:string,
    country?: string,
    state?: string,
    city?: string,
    zipcode?: string,
    category?: number | string,
    sort_by?: string,
    page?: number,
    size?: number}
) => async (dispatch: any) => {
  try {
    dispatch(nonprofitsAction.nonprofitsSlice());
    const response: any = await nonprofitsListApi(params);
    dispatch(nonprofitsAction.nonprofitsSliceSuccess(response));
  } catch (e: any) {
    dispatch(nonprofitsAction.nonprofitsSliceFailure(e?.response?.data?.message));
    dispatch(nonprofitsAction.nonprofitsSliceReset());
  }
};
export default nonprofitsSlice.reducer;
export const nonprofitsAction = nonprofitsSlice.actions;
